import ActionEnum from "./ActionEnum"

/** create Widget Action to set application data */
export function SetApplicationData(applicationDTO){
    return {
        type : ActionEnum.SET_APPLICATION_DATA,
        data : applicationDTO
    }
}

/** create Widget Action to set first holder data */
export function UpdateFirstHolderData(firstHolderData){
    return {
        type : ActionEnum.UPDATE_SECOND_HOLDER_DATA,
        data : firstHolderData
    }
}

/** create new action with action type and data */
export function createAction(actionType, data){
    return {
        type : actionType,
        data : data
    }
}
